export default __webpack_public_path__ + "static/media/ex.0c696aa3.jpeg";